import React, { useState } from 'react'
import { Layout, Menu, message } from 'antd'
import {
  Switch,
  Route,
  useHistory,
  useLocation,
  Redirect,
} from 'react-router-dom'
import styles from './index.module.scss'
import logo from '../../assets/logo.png'
import request from '../../utils/request'
import api from '../../api'
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
} from '@ant-design/icons'
import PersonalSettings from './PersonalSettings'
import RolesManagement from './RolesManagement'
import MemberManagement from './MemberManagement'
import MemberApplication from './MemberApplication'
import Productsubscription from './ProductSubscription'
import ApplMemberPage from './ApplMemberPage'
import OrderManagement from './AccountManagement/Order'
import EquityRecord from './AccountManagement/EquityRecord'
import { MyIcon } from '../../routers'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getMenuOfPersonal, getUserInfo, getMenus } from '../../store/actions/login'
import {
  getAdmin,
  getCreator,
  getDeploy,
  getCallbackUrl,
} from '../../utils/cookie'
import MyHeader from '../../components/MyHeader'
import {
  getCompany,
  getLogoUrl,
  getSuperGroup,
  getTitleName,
  removeCompany,
  removeOaOrg,
  removeSuperGroup,
  removeToken,
  removeUserStatus,
  setRedirectUrl,
  setSuperGroup,
  setToken,
} from '../../utils/cookie'
import { getLocationOrigin } from '../../utils/util'
import { urlMap } from '../../utils/urlMap'
import { useGetState } from 'ahooks'

const accountIcon = <svg t="1768801984295" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9997" id="mx_n_1768801984297" width="16" height="16"><path d="M245.4784 482.28864h238.51008V243.77344c0-131.71712-106.78784-238.51008-238.51008-238.51008S6.97344 112.04608 6.97344 243.77344s106.78784 238.5152 238.50496 238.5152zM1011.22048 243.77856c0-131.72224-106.78784-238.51008-238.5152-238.51008-131.72224 0-238.5152 106.78272-238.5152 238.51008v238.5152h238.5152c131.72736-0.01024 238.5152-106.79296 238.5152-238.5152zM772.7104 532.49536h-238.51008v238.5152c0 131.72736 106.78784 238.51008 238.51008 238.51008 131.71712 0 238.51008-106.78272 238.51008-238.51008-0.00512-131.72224-106.79296-238.5152-238.51008-238.5152zM17.21344 771.00032c0 131.71712 106.78272 238.51008 238.51008 238.51008 131.71712 0 238.5152-106.78784 238.5152-238.51008v-238.51008H255.72352c-131.72224 0.00512-238.51008 106.79296-238.51008 238.51008z" p-id="9998" fill="#ffffff"></path></svg>;
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  }
}

function getItems(userInfo, menus) {
  console.log(userInfo, menus, '111111')
  const hasAFC = menus.some((_) => _?.menu_code === 'AFC_PROD')
  const isCreatorOrAdmin = getCreator() || getAdmin()
  const showAccountManagement = hasAFC && isCreatorOrAdmin
  const accountManagement = getItem(
    '账户管理',
    '/saas/accountmanagement',
    accountIcon,
    [
      getItem('订单', '/saas/accountmanagement/order'),
      getItem('权益记录', '/saas/accountmanagement/equityrecord'),
    ]
  )
  //BOX部署 只有个人设置
  if (getDeploy() === 'BOX') {
    const items = [
      getItem(
        '个人设置',
        '/saas/personalsettings',
        <MyIcon type="icon-gerenshezhi1" />
      ),
    ]
    // BOX部署如果是管理员/创建者且有AFC，显示账户管理
    if (showAccountManagement) {
      items.push(accountManagement)
    }
    return items
  }
  //没有企业
  if (!userInfo.co_id) {
    return [
      getItem(
        '个人设置',
        '/saas/personalsettings',
        <MyIcon type="icon-gerenshezhi1" />
      ),
    ]
  }
  //个人版 有个人设置、产品订阅
  if (userInfo?.co_type_code === 'INDIV_ORG') {
    const items = [
      getItem(
        '个人设置',
        '/saas/personalsettings',
        <MyIcon type="icon-gerenshezhi1" />
      ),
      getItem(
        '产品订阅',
        '/saas/productsubscription',
        <MyIcon type="icon-chanpindingyue" />
      )
    ]
    if (showAccountManagement) {
      items.push(accountManagement)
    }
    return items
  }
  //企业版 创建者或者管理员  个人设置、产品订阅、企业管理
  if (getCreator() || getAdmin()) {
    const items = [
      getItem(
        '个人设置',
        '/saas/personalsettings',
        <MyIcon type="icon-gerenshezhi1" />
      ),
      // getItem(
      //   '账户管理',
      //   '/saas/accountmanagement',
      //   <MyIcon type="icon-zhanghuguanli1" />
      // ),
      getItem(
        '产品订阅',
        '/saas/productsubscription',
        <MyIcon type="icon-chanpindingyue" />
      )
    ]
    if (showAccountManagement) {
      items.push(accountManagement)
    }
    items.push(getItem(
        '企业管理',
        '/saas/businessmanagement',
        <MyIcon type="icon-qiyeguanli1" />,
        [
          getItem('新成员申请', '/saas/businessmanagement/memberapplication'),
          getItem('成员管理', '/saas/businessmanagement/membermanagement'),
          getItem('角色管理', '/saas/businessmanagement/rolesmanagement'),
        ]
      ))
    return items
  }
  //企业版 其他成员
  return [
    getItem(
      '个人设置',
      '/saas/personalsettings',
      <MyIcon type="icon-gerenshezhi1" />
    ),
    // getItem(
    //   '账户管理',
    //   '/saas/accountmanagement',
    //   <MyIcon type="icon-zhanghuguanli1" />
    // ),
    getItem(
      '产品订阅',
      '/saas/productsubscription',
      <MyIcon type="icon-chanpindingyue" />
    ),
    getItem(
      '成员列表',
      '/saas/businessmanagement/membermanagement',
      <MyIcon type="icon-qiyeguanli1" />
    ),
  ]
}

export default function SaasLayout() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  let pathname = location.pathname
  const { Header, Content, Sider } = Layout
  
  useEffect(() => {
    dispatch(getUserInfo())
    dispatch(getMenuOfPersonal())
    dispatch(getMenus({ not_check: true }))
  }, [dispatch])

  const userInfo = useSelector((state) => state.login.userInfo)
  
  const { personalMenus, licenseName, menus } = useSelector((state) => state.login)
  const onCheckPage = (e) => {
    history.push(e.key)
  }

  const confirm = () => {
    let redirect = window.location.origin + '/loginHtml'
    if (getCallbackUrl()) {
      redirect = getCallbackUrl()
    }
    request
      .post('sys/logout/', {
        redirect: redirect,
        saas: getDeploy() === 'BOX' ? undefined : true,
      })
      .then((res) => {
        if (res.data.data.status === 'redirect') {
          if (
            urlMap.noProject() ||
            urlMap.nofunc() ||
            urlMap.guidePage()
          ) {
            setRedirectUrl(getLocationOrigin() + '/home')
          } else {
            setRedirectUrl(window.location.href)
          }
          if (res.data.data.logout_url) {
            window.location.href = res.data.data.logout_url
          } else {
            window.location.reload()
          }
          removeToken()
          removeUserStatus()
          removeSuperGroup()
          removeCompany()
          removeOaOrg()
        }
      })
    message.success('退出成功')
  }

  //切换企业成功回调
  const switchEnterpriseSuccessFunc = (data) => {
    setToken(data?.data.token || '')
    sessionStorage.setItem('isEnterpriseSwitching', true)
    // setSuperGroup(data?.data.super_group || false)
    if (
      urlMap.noProject() ||
      urlMap.nofunc() ||
      urlMap.guidePage()
    ) {
      window.location.href = getLocationOrigin() + '/home'
      // history.push('/home')
      return
    }
    window.location.reload()
  }

  const menuClickCallBack = (item) => {
    if (item.menu_name === '帮助中心') {
      window.open(item.menu_url + '系统门户', item?.menu_name)
      return true
    }
  }

  return (
    <div className={styles.root}>
      <Layout className="saas_layout">
        <MyHeader
          logoDom={
            <div style={{ display: 'flex', width: '100%' }}>
              <div className="goback_btn">
                <MyIcon
                  onClick={() => {
                    //跳回之前的界面
                    let url = getCallbackUrl()
                    if (url) {
                      window.location.href = url
                    } else {
                      //如果 有企业跳到首页

                      history.push('/home')
                    }
                  }}
                  type="icon-fanhui"
                  style={{ fontSize: 22, fontWeight: 800 }}
                />
              </div>
              <div className="logo">
                <img src={localStorage.getItem('logo_url') || logo} alt="" />
              </div>
            </div>
          }
          showUserMenusMinLength={0}
          userInfo={userInfo}
          personalMenus={personalMenus}
          userMenus={[]}
          logoutBack={confirm}
          getUnreadNoticesFunc={api.getUnreadNotices}
          getNoticesFunc={api.getNotices}
          setReadNoticesFunc={api.setReadNotices}
          deleteNoticesFunc={api.deleteNotices}
          getUpdateLogList={api.getUpdateLogList}
          editCompName={api.editCompName}
          getEnterpriseFunc={api.getEnterprise}
          validationFunc={(res) => res.data?.code === 0 || res.code === 0}
          switchEnterpriseFunc={api.switchEnterpriseById}
          switchEnterpriseCallBack={switchEnterpriseSuccessFunc}
          licenseName={licenseName}
          projectCode="SYS_MANAGE"
          menuClickCallBack={menuClickCallBack}
        ></MyHeader>
        {/* <Header>
          {location.pathname !== '/invite' && (
            <div className="goback_btn">
              <MyIcon
                onClick={() => {
                  history.push('/home')
                }}
                type="icon-fanhui"
                style={{ fontSize: 22, fontWeight: 800 }}
              />
            </div>
          )}

          <div className="right_info">
            <div className="logo">
              <img src={logo} alt="" />
            </div>
            <div>
              <span>{userInfo?.show_name}</span>
              <img
                style={{
                  borderRadius: '50%',
                  width: 28,
                  height: 28,
                  margin: '0px 24px 0px 8px',
                }}
                src={userInfo?.pf_photo}
                alt=""
              />
            </div>
          </div>
        </Header> */}
        <Layout>
          {location.pathname !== '/invite' && (
            <Sider
              trigger={null}
              width={216}
              style={{
                background: 'linear-gradient(223deg, #006bb3 0%, #15d2d6 100%)',
              }}
              className="site-layout-background"
              collapsible
            >
              <Menu
                onClick={onCheckPage}
                mode="inline"
                style={{ height: '100%', borderRight: 0 }}
                items={getItems(userInfo, menus)}
                selectedKeys={[pathname]}
                defaultOpenKeys={['/saas/businessmanagement', '/saas/accountmanagement']}
              ></Menu>
            </Sider>
          )}

          <Content
            className="site-layout-background"
            id="right_content"
            style={{ position: 'relative' }}
          >
            <Switch key={location.key}>
              <Redirect
                exact
                from="/saas"
                to="/saas/personalsettings"
              ></Redirect>
              <Route
                path="/saas/businessmanagement/membermanagement"
                component={MemberManagement}
              ></Route>
              <Route
                path="/saas/businessmanagement/memberapplication"
                component={MemberApplication}
              ></Route>
              <Route
                path="/saas/businessmanagement/rolesmanagement"
                component={RolesManagement}
              ></Route>
              <Route
                path="/saas/productsubscription"
                component={Productsubscription}
              ></Route>
              <Route path="/invite" component={ApplMemberPage}></Route>
              <Route
                path="/saas/accountmanagement/order"
                component={OrderManagement}
              ></Route>
              <Route
                path="/saas/accountmanagement/equityrecord"
                component={EquityRecord}
              ></Route>
              <Route
                path="/saas/personalsettings"
                component={PersonalSettings}
              ></Route>
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </div>
  )
}
